// (c) 2018 Andreas Motl <andreas.motl@ip-tools.org>
'use strict';

import { StackDisplayMode } from "patzilla.navigator.components.stack/stack-core";
export { StackDisplayMode };
